export default function () {
  return useState('headerSlidingMenu', () => false)
}
